(function () {
  'use strict';

var scriptEl = document.currentScript;
  if (!scriptEl) {
    scriptEl = document.querySelector('script[id^="bownd-product-config-"]');
  }
  if (!scriptEl) { return; }

  var config = {
    sectionId: scriptEl.getAttribute('data-section-id'),
    thumbsDesktop: parseInt(scriptEl.getAttribute('data-thumbs-desktop'), 10) || 4,
    thumbsMobile: parseInt(scriptEl.getAttribute('data-thumbs-mobile'), 10) || 4,
    thumbsPosition: scriptEl.getAttribute('data-thumbs-position') || 'bottom',
    faqSelector: scriptEl.getAttribute('data-faq-selector') || ''
  };

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function getSection() {
    return document.getElementById('shopify-section-' + config.sectionId);
  }

  /* ---- Kaufzeile gruppieren ---- */
  function groupBuyRow(root) {
    toArray(root.querySelectorAll('.product-form')).forEach(function (form) {
      var qty = form.querySelector(':scope > .product-form__quantity');
      var buy = form.querySelector(':scope > .product-form__buy-buttons');
      if (!qty) { return; }
      if (!buy) { return; }
      if (form.querySelector('.product-buy-row')) { return; }

      var row = document.createElement('div');
      row.className = 'product-buy-row';
      form.insertBefore(row, qty);
      row.appendChild(qty);
      row.appendChild(buy);
    });
  }

  /* ---- Sticky-Sichtbarkeit ---- */
  function setupStickyVisibility(section) {
    var sticky = section.querySelector('product-sticky-form');
    var target = section.querySelector('.product-buy-row') || section.querySelector('.product-form__buy-buttons');
    var footer = document.querySelector('.shopify-section--footer');
    if (!sticky) { return; }
    if (!target) { return; }

    if (sticky.intersectionObserver) { sticky.intersectionObserver.disconnect(); }

    var buyVisible = true;
    var footerVisible = false;
    var pocketQuery = '(max-width: 740px)';
    if (window.themeVariables) {
      if (window.themeVariables.breakpoints) {
        if (window.themeVariables.breakpoints.pocket) {
          pocketQuery = window.themeVariables.breakpoints.pocket;
        }
      }
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === target) { buyVisible = e.intersectionRatio > 0; }
        if (e.target === footer) { footerVisible = e.intersectionRatio > 0; }
      });

      var isPocket = window.matchMedia(pocketQuery).matches;
      var hide = buyVisible;
      if (isPocket) {
        if (footerVisible) { hide = true; }
      }
      sticky.hidden = hide;
    });

    io.observe(target);
    if (footer) { io.observe(footer); }

    sticky.intersectionObserver = io;
  }

  /* ---- FAQs in den Hilfe-Drawer klonen ---- */
  function findFaqSource() {
    if (config.faqSelector) {
      var direct = document.querySelector(config.faqSelector);
      if (direct) { return direct; }
    }

    var found = null;
    toArray(document.querySelectorAll('[id^="shopify-section"]')).forEach(function (c) {
      if (found) { return; }
      if (/faq/i.test(c.id)) { found = c; return; }
      if (/faq/i.test(c.className)) { found = c; }
    });
    return found;
  }

  function cloneFaqIntoHelp(section) {
    var targets = toArray(section.querySelectorAll('[data-help-faq-target]'));
    if (targets.length === 0) { return; }

    var source = findFaqSource();
    if (!source) { return; }

    targets.forEach(function (target, idx) {
      if (target.dataset.filled) { return; }

      var clone = source.cloneNode(true);
      var suffix = '-helpclone-' + idx;

      if (clone.id) { clone.id = clone.id + suffix; }

      toArray(clone.querySelectorAll('[id]')).forEach(function (el) {
        el.id = el.id + suffix;
      });
      toArray(clone.querySelectorAll('[aria-controls]')).forEach(function (el) {
        el.setAttribute('aria-controls', el.getAttribute('aria-controls') + suffix);
      });
      toArray(clone.querySelectorAll('[name]')).forEach(function (el) {
        el.setAttribute('name', el.getAttribute('name') + suffix);
      });
      toArray(clone.querySelectorAll('[reveal]')).forEach(function (el) {
        el.removeAttribute('reveal');
      });
      toArray(clone.querySelectorAll('[reveal-on-scroll]')).forEach(function (el) {
        el.removeAttribute('reveal-on-scroll');
      });

      target.appendChild(clone);
      target.dataset.filled = '1';
    });
  }

  /* ---- Thumbnail-Breiten per Inline-Style (schlaegt jede CSS-Regel) ---- */
  function applyThumbSizing(section) {
    var isMobile = window.matchMedia('(max-width: 740px)').matches;
    var isDesk = window.matchMedia('(min-width: 1000px)').matches;

    if (isDesk) {
      if (config.thumbsPosition === 'left') { return; }
    }

    var perView = isMobile ? config.thumbsMobile : config.thumbsDesktop;
    var gap = isMobile ? 8 : 12;

    toArray(section.querySelectorAll('.product__thumbnail-list-inner')).forEach(function (list) {
      list.style.setProperty('display', 'flex', 'important');
      list.style.setProperty('flex-direction', 'row', 'important');
      list.style.setProperty('flex-wrap', 'nowrap', 'important');
      list.style.setProperty('gap', gap + 'px', 'important');
    });

    var items = toArray(section.querySelectorAll('.product__thumbnail-item'));
    if (items.length === 0) {
      console.warn('[bownd] Keine .product__thumbnail-item gefunden – Markup nutzt andere Klassen.');
      return;
    }

    var basis = 'calc((100% - ' + ((perView - 1) * gap) + 'px) / ' + perView + ')';
    items.forEach(function (el) {
      el.style.setProperty('flex', '0 0 ' + basis, 'important');
      el.style.setProperty('width', basis, 'important');
      el.style.setProperty('min-width', '0', 'important');
      el.style.setProperty('max-width', 'none', 'important');
      el.style.setProperty('margin', '0', 'important');
    });
  }

  /* ---- Init ---- */
  function run() {
    var section = getSection();
    if (!section) { return; }

    groupBuyRow(section);
    cloneFaqIntoHelp(section);
    applyThumbSizing(section);

    if (window.customElements) {
      if (customElements.whenDefined) {
        customElements.whenDefined('product-sticky-form').then(function () {
          requestAnimationFrame(function () { setupStickyVisibility(section); });
        });
        return;
      }
    }
    setupStickyVisibility(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('variant:change', run);
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail) { return; }
    if (e.detail.sectionId === config.sectionId) { run(); }
  });

  var resizeRaf;
  window.addEventListener('resize', function () {
    if (resizeRaf) { cancelAnimationFrame(resizeRaf); }
    resizeRaf = requestAnimationFrame(function () {
      var section = getSection();
      if (section) { applyThumbSizing(section); }
    });
  });
})();
/* ---- Judge.me App-Block ueber den Produkttitel ziehen ----
   Focal rendert product-meta (inkl. Titel) vor der Block-Schleife.
   Der @app-Block kann strukturell also nie oben stehen -> wir haengen ihn per JS um.
   Es wird der ECHTE App-Block verschoben, damit Sprache, Styling und der
   Anker-Link zur Review-Section unten erhalten bleiben. */
(function () {
  var moving = false;

  function moveRating(info) {
    var title = info.querySelector('.product-meta__title');
    if (!title) return;

    /* Preview-Badge im Info-Bereich suchen - NICHT das grosse Review-Widget unten */
    var badge = info.querySelector('.jdgm-preview-badge, .jdgm-prev-badge, .jdgm-widget--preview-badge');
    if (!badge) return;

    var host = badge.closest('.shopify-app-block') || badge;
    if (!info.contains(host)) return;
    if (title.previousElementSibling === host) return; /* steht schon oben */

    moving = true;
    title.parentElement.insertBefore(host, title);
    host.classList.add('bownd-rating--above-title');
    moving = false;
  }

  function run() {
    document.querySelectorAll('.product__info').forEach(moveRating);
  }

  function boot() {
    run();

    /* Judge.me laedt asynchron nach, product-rerender tauscht das DOM bei Variantenwechsel */
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (moving || scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    });

    document.querySelectorAll('product-rerender').forEach(function (node) {
      observer.observe(node, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();